import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import io from "socket.io-client";

import Loader from "./Dashboard Components/Loader.jsx";
import ContactList from "./Dashboard Components/ContactList.jsx";
import ChatArea from "./Dashboard Components/ChatArea.jsx";
import Dashboardheader from "./Dashboard Components/DashboardHeader.jsx";
import dashboardCss from "../styles/Dashboard Styles/dashboard.module.scss";
import contactCss from "../styles/Dashboard Styles/contact.module.scss";

import appLogo from "../assets/appLogo.png";

function Dashboard() {
  const navigate = useNavigate();

  const [user, setUser] = useState({});
  const [display, setDisplay] = useState(false);
  const [allContacts, setAllContacts] = useState([]);
  const [selectedUser, setSelectedUser] = useState({});
  const [userActive, setUserActive] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [socket, setSocket] = useState();

  // Sort Contacts According To Their Names

  function sortContactList(allContacts) {
    function sortArray(cont1, cont2) {
      const nameA = cont1.username.toUpperCase();
      const nameB = cont2.username.toUpperCase();

      if (nameA < nameB) {
        return -1;
      } else if (nameA > nameB) {
        return 1;
      }
    }

    if (allContacts.length !== 0) {
      let sortedArray = allContacts.sort(sortArray);

      return sortedArray;
    }
  }

  useEffect(() => {
    // Token Checking
    let token = localStorage.getItem("chatappsessiontoken");
    if (token === null) {
      navigate("/");
    } else {
      async function fetchUserData() {
        let userData = await axios.post(
          "https://chatwave-b-api.onrender.com/getData",
          // "http://localhost:2005/getData",
          {
            token,
            secret: "thisisasecretkeyforreactchatappnamedchatwave",
          }
        );

        let contacts = await axios.post(
          "https://chatwave-b-api.onrender.com/allUsers",
          // "http://localhost:2005/allUsers",
          {
            secret: "thisisasecretkeyforreactchatappnamedchatwave",
          }
        );

        console.log(userData.data);
        console.log(contacts.data);

        if (userData.data.status && contacts.data.status) {
          let tempContacts = [];

          contacts.data.users.forEach((contact) => {
            if (contact._id !== userData.data.id) {
              tempContacts.push(contact);
            }
          });

          let sortedList = sortContactList(tempContacts);
          setAllContacts(sortedList);
          setLoaded(true);
          setUser(userData.data);
        }
      }

      fetchUserData();

      // Socket Operations

      const socket = io(
        "https://chatwave-b-api.onrender.com/",
        // "http://localhost:2005/",
        {
          auth: {
            token: localStorage.getItem("chatappsessiontoken"),
          },
        }
      );

      setSocket(socket);

      socket.on("updateStatus", async ({ token }) => {
        let allUsers = await axios.post(
          "https://chatwave-b-api.onrender.com/allUsers",
          // "http://localhost:2005/allUsers",
          {
            secret: "thisisasecretkeyforreactchatappnamedchatwave",
          }
        );

        let userData = await axios.post(
          "https://chatwave-b-api.onrender.com/getData",
          // "http://localhost:2005/getData",
          {
            token: localStorage.getItem("chatappsessiontoken"),
            secret: "thisisasecretkeyforreactchatappnamedchatwave",
          }
        );

        if (userData.data.status && allUsers.data.status) {
          let tempContacts = [];

          allUsers.data.users.forEach((contact) => {
            if (contact._id !== userData.data.id) {
              tempContacts.push(contact);
            }
          });

          let sortedList = sortContactList(tempContacts);

          setAllContacts(sortedList);
        }
      });

      return () => {
        socket.disconnect();
      };
    }
  }, [navigate]);

  // Show/Hide Chat

  useEffect(() => {
    let contactClass = contactCss.contact;
    let contacts = document.getElementsByClassName(contactClass);
    Array.from(contacts).forEach((contact, index) => {
      contact.addEventListener("click", () => {
        setSelectedUser(allContacts[index]);
        if (allContacts[index].onlineStatus) {
          setUserActive(true);
        } else {
          setUserActive(false);
        }
        setDisplay(true);
      });
    });
  });

  useEffect(() => {
    if (Object.keys(selectedUser).length !== 0) {
      allContacts.forEach((user) => {
        if (user._id === selectedUser._id) {
          setUserActive(user.onlineStatus);
        }
      });
    }
  }, [allContacts, selectedUser]);

  return (
    <>
      {loaded ? (
        <>
          <Dashboardheader name={user.username} userId={user.id} />
          <div className={dashboardCss.chatArea}>
            <div className={dashboardCss.contactElements}>
              {allContacts !== undefined ? (
                <ContactList users={allContacts} />
              ) : (
                <ContactList users={[]} />
              )}
            </div>
            <div className={dashboardCss.chatElements}>
              {display ? (
                <ChatArea
                  selectedUser={selectedUser}
                  userActiveStatus={userActive}
                  closeChatFunction={() => {
                    setDisplay(false);
                  }}
                  socket={socket}
                />
              ) : (
                <>
                  <div className={dashboardCss.start}>
                    <img src={appLogo} alt="logo" />
                    <h2>Chatwave</h2>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      ) : (
        <Loader />
      )}
    </>
  );
}

export default Dashboard;
